<template>
  <div class="elpris">
    <div class="back-nav">
      <router-link :to="{ name: 'start' }" class="step-nav__link back-button"><Arrow /> Tillbaka</router-link>
    </div>
    <h1 class="elpris__title">Uppskatta din årsförbrukning</h1>
    <p class="elpris__subtitle">För att kunna räkna ut din månadskostnad behöver vi veta din ungefärliga årsanvändning. Välj bostadstyp och fyll din användning nedan.</p>
    <form class="elpris__form" @submit.prevent="submit($event)">
      <div class="elpris__types">
        <label class="elpris__type">
          <input type="radio" v-model="$root.type" name="type" value="apartment" required class="elpris__type-field">
          <span class="elpris__type-label">
            <Building />
            Lägenhet
          </span>
        </label>
        <label class="elpris__type">
          <input type="radio" v-model="$root.type" name="type" value="house" required class="elpris__type-field">
          <span class="elpris__type-label">
            <Building />
            Hus / Radhus
          </span>
        </label>
        <label class="elpris__type">
          <input type="radio" v-model="$root.type" name="type" value="big_house" required class="elpris__type-field">
          <span class="elpris__type-label">
            <Building />
            Stort hus
          </span>
        </label>
      </div>
      <div class="elpris__estimated">
        <label class="elpris__estimated-wrapper toggle">
          <input type="checkbox" v-model="$root.estimated" class="toggle__field">
          <span class="toggle__label">
            Jag vet inte min årsförbrukning
          </span>
        </label>
      </div>
      <div v-if="$root.estimated">
        <div class="elpris__estimated-fields">
        <template v-if="$root.type !== 'apartment'">
          <label class="elpris__estimated-field-wrapper elpris__estimated-field-wrapper--dropdown">
            Typ av uppvärming
            <select v-model="$root.heater_type" class="elpris__estimated-field" required>
              <option :value="null">Välj</option>
              <option value="electric">Electric</option>
              <option value="pellet">Pellet</option>
              <option value="biofuel">Biofuel</option>
            </select>
          </label>
        </template>
        <label class="elpris__estimated-field-wrapper">Antal personer <input type="number" v-model="$root.people" min="1" class="elpris__estimated-field" required></label>
        <label class="elpris__estimated-field-wrapper">Kvadratmeter <input type="number" v-model="$root.surface" min="40" class="elpris__estimated-field" required></label>
        </div>
        <dl class="elpris__estimated-calculation">
          <dt class="elpris__estimated-calculation-title">Beräknad årsförbrukning</dt>
          <dd class="elpris__estimated-calculation-text"><b>{{$root.watts}}</b> kWh/år</dd>
        </dl>
      </div>
      <div class="elpris__direct-watts" v-else>
        <label class="elpris__direct-watts-label"><input type="number" v-model="$root.direct_watts" class="elpris__direct-watts-field" required>kWh/år</label>
        <input type="range" v-model="$root.direct_watts" min="1000" max="30000" step="100" class="elpris__direct-watts-range">
      </div>
      <div class="elpris__price-types">
        <h2 class="elpris__price-types-title">Välj avtal</h2>
        <p class="elpris__price-types-subtitle">Svårt att välja? <a href="#">Vi kan hjälpa dig</a></p>
        <ul class="elpris__price-types-list">
          <li class="elpris__price-types-list-item">
            <label class="elpris__price-type">
              <input type="radio" v-model="$root.price_type" name="price_type" value="variable" class="elpris__price-type-field" required>
              <span class="elpris__price-type-label">Rörligt pris <small>från ca <b>{{$root.variable_price}}</b> kr/mån</small></span>
            </label>
          </li>
          <li class="elpris__price-types-list-item">
            <label class="elpris__price-type">
              <input type="radio" v-model="$root.price_type" name="price_type" value="fixed" class="elpris__price-type-field" required>
              <span class="elpris__price-type-label">Fast pris <small>från ca <b>{{$root.fixed_price}}</b> kr/mån</small></span>
            </label>
          </li>
        </ul>
      </div>
      <div class="elpris__commitment">
        <h2 class="elpris__commitment-title">Avtalstid</h2>
        <template v-for="term in [1,2,3,4,5]">
          <label :key="term+'year'" class="elpris__commitment-wrapper">
            <input type="radio" v-model="$root.commitment" name="commitment" class="elpris__commitment-field" :value="term" required>
            <span class="elpris__commitment-label">{{term}} år</span>
          </label>
        </template>
      </div>
      <div class="elpris__summary">
        <h2 class="elpris__summary-title">{{$root.price_type === 'fixed' ? 'Fast pris' : 'Rörligt pris'}} {{$root.commitment}} år</h2>
        <p class="elpris__summary-subtitle">ca <b>{{$root.price_type === 'fixed' ? $root.fixed_price : $root.variable_price}}</b> kr/mån <i>*</i></p>
        <div class="elpris__summary-features">
          <p class="elpris__summary-feature"><Checkmark /> Ingen årsavgift</p>
          <p class="elpris__summary-feature"><Checkmark /> El från 100% förnybara källor</p>
          <p class="elpris__summary-feature"><Checkmark /> Ingen risk för säsongsvariationer</p>
          <p class="elpris__summary-feature"><Checkmark /> Du vet vad du kommer att betala</p>
        </div>
        <p class="elpris__summary-content">Fast pris betyder att du betalar samma pris per kilowattimme oavsett vad som händer på elmarknaden. Detta alternativet passar dig som inte vill engagera dig mer än nödvändigt och tycker att trygghet är viktigt.</p>
        <h3 class="elpris__summary-content-title">Jämförpris</h3>
        <p class="elpris__summary-content">Jämförpriset inkluderar alla kostnader</p>
        <ul class="summary">
          <li class="summary__item"><span><b>2 000 kWh</b></span> <span><b>65.15</b> öre/kWh</span></li>
          <li class="summary__item"><span><b>5 000 kWh</b></span> <span><b>54.71</b> öre/kWh</span></li>
          <li class="summary__item"><span><b>20 000 kWh</b></span> <span><b>49.49</b> öre/kWh</span></li>
        </ul>
        <details class="elpris__summary-details">
          <h3 class="elpris__summary-content-title">Din uppskattade användning</h3>
          <ul class="summary">
            <li class="summary__item"><span><b>Årlig användning</b></span> <span><b>16883</b> kWh</span></li>
            <li class="summary__item"><span><b>Varje månad</b></span> <span><b>1407</b> kWh</span></li>
          </ul>
          <h3 class="elpris__summary-content-title">Kostnad användning</h3>
          <ul class="summary">
            <li class="summary__item"><span>Fast elpris 1 år inkl. certifikatkostnad </span> <span>38.20 öre/kWh</span></li>
            <li class="summary__item"><span>100% förnybar el</span> <span>0,00 öre/kWh</span></li>
            <li class="summary__item"><span>Moms</span> <span>9.55 öre/kWh</span></li>
            <li class="summary__item"><span><b>Totalt elpris</b></span> <span><b>47.75</b> öre/kWh</span></li>
            <li class="summary__item"><span><b>Fast avgift</b> (inkl moms)</span> <span><b>29</b> kr/mån</span></li>
          </ul>
          <summary class="elpris__summary-details-title">Detaljerat pris <ChevronDown /></summary>
        </details>
      </div>
      <p class="elpris__summary-disclaimer">
        <b>*</b> Prisberäkningen är ett uppskattat genomsnittligt månadspris som baseras på den angivna elanvändningen. Det uppskattade priset inkluderar samtliga avgifter. Tänk på att månadskostnaden kan variera beroende på din faktiska elanvändning. Kostnad för elnätsavgiften tillkommer.
      </p>
      <div class="step-nav">
        <button type="submit" class="button button--with-icon step-nav__button">Mina uppgifter <Arrow /></button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  methods: {
    submit() {
      this.$router.push({ name: 'uppgifter' })
    }
  },
}
</script>
<style lang="scss">
  @import '~@/components/range/range';
  .elpris {
    &__title {
      text-align: center;
      margin: 0;
      @include font-primary(bold);
      @include media('>lg') {
        font-size: rem(26);
      }
      @include media('<=lg') {
        font-size: rem(22);
        line-height: (36/22);
      }
    }
    &__subtitle {
      text-align: center;
      @include media('>lg') {
        margin: rem(14) 0 rem(40);
        font-size: rem(18);
        line-height: (28/18);
      }
      @include media('<=lg') {
        margin: rem(13) 0 rem(28);
        font-size: rem(15);
        line-height: (23/15);
      }
    }
    &__types {
      display: flex;
    }
    &__type {
      flex: 1 1;
      text-align: center;
    }
    &__type-field {
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
    }
    &__type-label {
      @include font-primary(bold);
      height: 100%;
      @include media('>lg') {
        font-size: 18px;
        line-height: (23/18);
      }
      @include media('<=lg') {
      }
      display: block;
      position: relative;
      border: 1px solid $light-border-color;
      padding: rem(34 + 16 + 26) rem(16) rem(16);
      svg {
        position: absolute;
        width: auto;
        height: rem(34);
        left: 50%;
        transform: translate(-50%, 0);
        top: rem(26);
      }
    }
    &__type:not(:first-child) &__type-label {
      margin-left: -1px;
    }
    &__type:first-child &__type-label {
      border-top-left-radius: rem(3);
      border-bottom-left-radius: rem(3);
    }
    &__type:last-child &__type-label {
      border-top-right-radius: rem(3);
      border-bottom-right-radius: rem(3);
    }
    &__type:hover &__type-label {
      border-color: $dark-border-color;
      z-index: 1;
    }
    &__type-field:checked + &__type-label {
      border-color: $primary-color;
      border-width: 2px;
      margin-left: -2px;
      z-index: 2;
    }
    &__type-field:focus + &__type-label {
      border-color: $dark-border-color;
      z-index: 1;
    }
    &__estimated {
      text-align: center;
      margin: rem(32) 0;
    }
    &__direct-watts {
      text-align: center;
      margin: rem(29) 0;
    }
    &__direct-watts-label {
      display: block;
      color: $secondary-text-color;
      @include media('>lg') {
        font-size: rem(22);
      }
      @include media('<=lg') {
        font-size: rem(15);
      }
      margin-bottom: rem(26);
    }
    &__direct-watts-field {
      @include unstyled-text-field;
      @include font-primary(bold);
      width: 4em;
      @include media('>lg') {
        font-size: rem(46);
        margin-right: rem(19);
      }
      @include media('<=lg') {
        font-size: rem(26);
        margin-right: rem(12);
      }
      border-bottom: 2px solid $primary-color;
      text-align: center;
      color: $primary-color;
    }
    &__direct-watts-range {
      @include range;
    }
    &__price-types {
      @include media('>lg') {
        margin: rem(29) 0;
      }
      @include media('<=lg') {
        margin: rem(30) 0 rem(15);
      }
    }
    &__price-types-title {
      @include font-primary(bold);
      float: left;
      color: $secondary-text-color;
      margin: 0;
      line-height: 1.4rem;
      @include media('>lg') {
        font-size: rem(22);
      }
      @include media('<=lg') {
        font-size: rem(18);
      }
    }
    &__price-types-subtitle {
      margin: 0;
      float: right;
      line-height: 1.4rem;
      @include media('>lg') {
        font-size: rem(16);
      }
      @include media('<=lg') {
        font-size: rem(13);
      }
      a {
        color: $primary-color;
      }
    }
    &__price-types-list {
      clear: both;
      display: flex;
      margin: 0;
      padding: 0;
      list-style-type: none;
      @include media('>lg') {
        padding-top: rem(15);
      }
      @include media('<=lg') {
        padding-top: rem(11);
      }
    }
    &__price-types-list-item {
      margin: 0;
      padding: 0;
      flex: 1 1;
    }
    &__price-type {
      position: relative;
    }
    &__price-type-field {
      position: absolute;
      opacity: 0;
    }
    &__price-type-label {
      display: block;
      height: 100%;
      cursor: pointer;
      border: 1px solid $light-border-color;
      text-align: center;
      padding: rem(17) 0;
      small {
        display: block;
      }
      @include media('>lg') {
        @include font-primary(bold);
        font-size: rem(36);
        small {
          @include font-primary;
          font-size: rem(22);
        }
      }
      @include media('<=lg') {
        @include font-primary(bold);
        font-size: rem(22);
        small {
          @include font-primary;
          font-size: rem(15);
        }
      }
      &:hover {
        border-color: $dark-border-color;
        z-index: 1;
      }
    }
    &__price-types-list-item:not(:first-child) &__price-type-label {
      margin-left: -1px;
    }
    &__price-types-list-item:first-child &__price-type-label {
      border-top-left-radius: rem(3);
      border-bottom-left-radius: rem(3);
    }
    &__price-types-list-item:last-child &__price-type-label {
      border-top-right-radius: rem(3);
      border-bottom-right-radius: rem(3);
    }
    
    &__price-type-field:checked + &__price-type-label {
      border-color: $primary-color;
      background: $primary-color;
      color: #fff;
      z-index: 2;
    }
    &__price-type-field:focus + &__price-type-label {
      background-color: $light-bg-color;
    }
    &__price-type-field:checked:focus + &__price-type-label,
    &__price-type-field:checked + &__price-type-label:hover {
      background-color: darken($primary-color, 10%);
    }
    &__commitment {
      display: flex;
      align-items: center;
      @include media('>lg') {
      }
      @include media('<=lg') {
        flex-wrap: wrap;
      }
    }
    &__commitment-title {
      font-size: inherit;
      margin: 0;
      color: $secondary-text-color;
      @include media('<=lg') {
        margin-bottom: rem(14);
        flex-basis: 100%;
      }
    }
    &__commitment-wrapper {
      position: relative;
      @include media('>lg') {
        padding-left: rem(16);
      }
      @include media('<=lg') {
        padding-left: rem(13);
      }
    }
    &__commitment-title + &__commitment-wrapper {
      @include media('>lg') {
        padding-left: rem(25);
      }
      @include media('<=lg') {
        padding-left: 0;
      }
    }
    &__commitment-field {
      position: absolute;
      opacity: 0;
    }
    &__commitment-label {
      display: block;
      color: $primary-color;
      border: 1px solid $light-border-color;
      border-radius: 3px;
      line-height: 1;
      padding: rem(8) rem(15);
      white-space: nowrap;
      cursor: pointer;
      @include media('>lg') {
        font-size: rem(16);
      }
      @include media('<=lg') {
        font-size: rem(15);
      }
      &:hover {
        border-color: $dark-border-color;
      }
    }
    &__commitment-field:checked + &__commitment-label {
      background-color: $primary-color;
      border-color: $primary-color;
      color: #fff;
    }
    &__commitment-field:checked + &__commitment-label:hover,
    &__commitment-field:checked:focus + &__commitment-label {
        background-color: darken($primary-color, 10%);
    }
    &__summary {
      background-color: $light-bg-color;
      @include media('>lg') {
        padding: rem(24);
        margin: rem(31) 0 rem(24);
      }
      @include media('<=lg') {
        padding: rem(16);
        margin: rem(24) rem(-16) rem(16);
      }

    }
    &__summary-content {
      @include media('>lg') {
        font-size: rem(16);
        line-height: rem(24);
      }
      @include media('<=lg') {
        font-size: rem(13);
        line-height: rem(21);
      }
      color: $secondary-text-color;
    }
    &__summary-content-title {
      @include font-primary;
      @include media('>lg') {
        font-size: rem(26);
        margin: rem(35) 0 rem(16);
      }
      @include media('<=lg') {
        font-size: rem(22);
        margin: rem(26) 0 rem(10);
      }
      line-height: rem(24);
    }
    &__summary-details {
      position: relative;
      @include media('>lg') {
        padding-bottom: rem(40);
      }
      @include media('<=lg') {
        padding-bottom: rem(38);
      }

    }
    &__summary-details-title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      cursor: pointer;
      color: $primary-color;
      @include media('>lg') {
        font-size: rem(16);
      }
      @include media('<=lg') {
        font-size: rem(15);
      }

      line-height: rem(22);
      svg {
        width: rem(10);
        height: rem(10);
      }
      path {
        fill: $primary-color;
      }
      
      list-style-type: none;
      &::marker {
        display: none;
      }
      &::-webkit-details-marker {
        display: none;
      }
    }
    &__summary-details[open] &__summary-details-title svg {
      transform: rotate(180deg);
    }
    &__summary-title {
      @include font-primary(bold);
      @include media('>lg') {
        font-size: rem(22);
      }
      @include media('<=lg') {
        font-size: rem(18);
      }
      margin: 0;
    }
    &__summary-subtitle {
      margin: 0;
      @include media('>lg') {
        font-size: rem(36);
      }
      @include media('<=lg') {
        margin: rem(8) 0;
        font-size: rem(26);
      }

      line-height: 49/36;
      b {
        @include font-primary(bold);
        color: $primary-color;
      }
      i {
        color: #c00;
        font-style: normal;
      }
    }
    &__summary-disclaimer {
      color: $secondary-text-color;
      @include font-primary(roman);
      font-size: rem(13);
      b {
        color: #c00;
      }
    }
    &__summary-features {
      @include media('>lg') {
        display: flex;
        flex-wrap: wrap;
        margin: 0 rem(-16) 0 0;
      }
    }
    &__summary-feature {
      @include font-primary(bold);
      flex-basis: 50%;
      position: relative;
      margin: 0;
      @include media('>lg') {
        padding: rem(8) rem(16) rem(8) rem(32);
        font-size: rem(16);
      }
      @include media('<=lg') {
        padding: rem(8) 0 rem(8) rem(32);
        font-size: rem(15);
      }
      svg {
        position: absolute;
        left: 0;
        top: rem(16/2);
        width: rem(16);
        height: rem(16);
      }
      polygon {
        fill: $primary-color;
      }
    }
    &__estimated-fields {
      @include media('>lg') {
        display: flex;
        margin: 0 rem(-12);
      }
      @include media('<=lg') {
      }
    }
    &__estimated-field-wrapper {
      @include font-primary(bold);
      color: $secondary-text-color;
      @include media('>lg') {
        font-size: rem(18);
        flex: 1 1;
        margin: 0 rem(12);
      }
      @include media('<=lg') {
        font-size: rem(16);
        display: block;
        margin: 1rem 0 0;
      }
      &--dropdown {
        position: relative;
        &:before {
          content: '';
          position: absolute;
          right: rem(16+(14*2));
          bottom: 0;
          height: rem(16+(14*2));
          border-left: 1px solid $light-border-color;
        }
        select {
          background-image: url('~@/assets/images/icons/chevron-down-regular.svg');
          background-repeat: no-repeat;
          background-position: calc(100% - 1em) 50%;
          cursor: pointer;
        }
      }
    }
    &__estimated-field {
      @include unstyled-text-field;
      @include font-primary;
      border: 1px solid $light-border-color;
      &:hover,
      &:focus {
        border-color: $primary-color;
      }
      padding: rem(14);
      height: rem(16+(14*2));
      line-height: 1;
      display: block;
      width: 100%;
      margin: rem(12) 0 0;
      @include media('>lg') {
        font-size: rem(16);
      }
      @include media('<=lg') {
        font-size: rem(15);
      }
    }
    &__estimated-calculation {
      text-align: center;
    }
    &__estimated-calculation-title {
      @include font-primary;
      margin: 0;
      padding: 0;
      @include media('>lg') {
        font-size: rem(16);
      }
      @include media('<=lg') {
        font-size: rem(15);
      }
    }
    &__estimated-calculation-text {
      @include font-primary;
      margin: 0;
      padding: 0;
      b {
        vertical-align: middle;
      }
      @include media('>lg') {
        font-size: rem(22);
        b {
          font-size: rem(46);
        }
      }
      @include media('<=lg') {
        font-size: rem(15);
        b {
          font-size: rem(26);
        }
      }
    }
  }
</style>
